import React from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import {LOOK_OVERLAYS} from "../../../look/core/constants";
import {setLookAiImageOpened} from "../../aiActions";
import LookAIImagesOverlayItem from "./LookAIImagesOverlayItem";
import {IS_QKB_UI} from "../../../../config";


const LookAIImagesOverlay = (props) => {

  const {lookAiVisited, lookOverlayOpened, lookAiImageOpened, setLookAiImageOpened, aiResults, intl, showLeadOverlay,
    isMobile, showImagesListOverlay, aiImageExpanded} = props;

  if (!lookAiVisited || isMobile) {
    return null
  }

  const closeAIImageOverlay = () => {
    setLookAiImageOpened(false);
  }

  const aiOpened = (lookOverlayOpened === LOOK_OVERLAYS.aiPanel);

  return (
    <div className={"fixed transition2 h-full top-0 look-ai__images-panel flex flex--column"
      + (aiOpened && !aiImageExpanded ? "" : " left-0")
      + (IS_QKB_UI ? " left-0 look-ai__images-panel--qkb" : "")
      + (aiOpened && lookAiImageOpened && !showLeadOverlay && showImagesListOverlay && !aiImageExpanded
        ? " look-ai__images-panel--opened" : "")}>
      <div className="look-ai__content w-full p-1 bg-white flex--1 scrollable">
        <div className="flex flex--center flex--between mb-05 mt-05">
          <h2 className="bold font--16 m-0">
            <FormattedMessage id={"look.ai.images.panel.title"}/>
          </h2>
          <IconButton aria-label={intl.formatMessage({id: "iconButton.close"})}
                      className="look-icon look-icon--small"
                      onClick={closeAIImageOverlay}>
            <CloseIcon/>
          </IconButton>
        </div>
        <ul className="m-0 p-0">
          {aiResults.map((aiResult, aiResultIndex) => <LookAIImagesOverlayItem key={aiResult.id || aiResultIndex}
                                                                               aiResult={aiResult}/>)}
        </ul>
      </div>
    </div>
  )
};

LookAIImagesOverlay.propTypes = {
  showLeadOverlay: PropTypes.bool.isRequired,
  showImagesListOverlay: PropTypes.bool.isRequired,
}

const mapStateToProps = (store) => {
  const {lookOverlayOpened} = store.lookState;
  const {lookAiImageOpened, lookAiVisited, aiResults, aiImageExpanded} = store.aiState;
  const {isMobile} = store.serverState;

  return {
    lookOverlayOpened,
    lookAiImageOpened,
    lookAiVisited,
    aiResults,
    isMobile,
    aiImageExpanded,
  };
};

const mapDispatchToProps = {
  setLookAiImageOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookAIImagesOverlay)
)
